import type {
  AmplifierUpgradeGuardMs,
  HoverChargeDuration,
  HoverToggleDuration,
  MHovChargeDurationMs,
  NHovAnimationSpeed,
  NHovChargeDurationMs,
  OHovChargeDurationMs,
} from "../types";

export function isMHovChargeDurationMs(
  value: unknown,
): value is MHovChargeDurationMs {
  return value === 0 || value === 2000 || value === 5000;
}

export function isNHovAnimationSpeed(
  value: unknown,
): value is NHovAnimationSpeed {
  return value === "normal" || value === "fast" || value === "instant";
}

export function isNHovChargeDurationMs(
  value: unknown,
): value is NHovChargeDurationMs {
  return value === 0 || value === 2000 || value === 5000;
}

export function isOHovChargeDurationMs(
  value: unknown,
): value is OHovChargeDurationMs {
  return value === 0 || value === 2000 || value === 5000;
}

export function isHoverToggleDuration(
  value: unknown,
): value is HoverToggleDuration {
  return value === "short" || value === "normal";
}

export function resolveHoverToggleDurationMs(value: unknown): number {
  if (value === "short") return 1000;
  return 2000;
}

export function isHoverChargeDuration(
  value: unknown,
): value is HoverChargeDuration {
  return value === "short" || value === "normal";
}

export function resolveHoverChargeDurationMs(value: unknown): number {
  if (value === "short") return 1000;
  return 2000;
}

export function isAmplifierUpgradeGuardMs(
  value: unknown,
): value is AmplifierUpgradeGuardMs {
  return value === 0 || value === 1000 || value === 3000;
}

export function resolveAmplifierUpgradeGuardMs(
  value: unknown,
): AmplifierUpgradeGuardMs {
  return isAmplifierUpgradeGuardMs(value) ? value : 0;
}
